<template>
  <div v-if="hasRedeemableVoucher" class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-8 md:px-6 lg:px-8 xl:px-20 xl:mb-12">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="3"
          />
        </div>
      </div>

      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg xl:space-y-6">
            <h1 class="text-3xl font-bold leading-none uppercase xl:text-4xl">
              {{ tr('pages.sales.confirmation.title') }}
            </h1>
            <p class="xl:leading-7.5 xl:text-2xl">
              {{ tr('pages.sales.confirmation.description') }}
              {{ tr('pages.sales.confirmation.descriptionLineTwo') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-6 pb-16 viewport-gutter xl:pt-16 xl:pb-32">
      <div class="container">
        <div class="flex flex-col-reverse items-center justify-between w-full xl:items-start xl:max-w-5xl xl:flex-row xl:mx-auto xl:space-x-20">
          <div class="w-full max-w-lg">
            <div class="space-y-8">
              <div class="w-full rounded shadow xl:w-full">
                <div class="flex items-center justify-between px-5 py-4 space-x-3 bg-white rounded-t">
                  <div class="flex-shrink-0 w-24">
                    <svg viewBox="0 0 114 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_644_56)"><path d="M82.048 21.291h-4.316V4.652h4.316v16.64zM71.826 4.652L69.04 15.803l-3.255-11.15h-4.175l-3.253 11.15-2.787-11.15h-4.232L55.93 21.29h4.47l3.292-11.41 3.296 11.41h4.459l4.606-16.639h-4.227zm-20.841 11.93c0-3.18-1.693-4.259-5.393-5.465-1.744-.568-3.373-1.006-3.373-2.362 0-1.189 1.21-1.59 2.115-1.59.765 0 2.205.16 2.321 1.926h4.089c-.07-3.369-2.81-4.836-6.338-4.836-2.185 0-3.99.62-5.129 1.74a4.427 4.427 0 00-1.276 3.12c0 3.1 2.07 4.34 4.407 5.05 2.628.802 4.365 1.282 4.365 2.726 0 .966-.767 1.929-2.271 1.929-1.922 0-2.62-1.136-2.665-2.272h-4.134c0 3.835 3.232 5.238 6.799 5.238 4.543 0 6.492-2.594 6.492-5.21m46.34 0c0-3.67-2.67-4.64-5.907-5.604-1.556-.455-2.953-.868-2.953-2.224 0-1.188 1.209-1.59 2.115-1.59.77 0 2.203.16 2.32 1.926h4.088c-.07-3.369-2.808-4.836-6.34-4.836-2.183 0-3.995.62-5.127 1.74a4.437 4.437 0 00-1.276 3.12c0 3.1 2.064 4.34 4.409 5.05 2.626.802 4.368 1.282 4.368 2.726 0 .966-.766 1.929-2.272 1.929-1.926 0-2.626-1.136-2.666-2.272h-4.135c0 3.835 3.23 5.238 6.801 5.238 4.543 0 6.572-2.594 6.572-5.21m14.865 0c0-3.669-2.683-4.639-5.906-5.604-1.561-.455-2.953-.868-2.953-2.224 0-1.188 1.202-1.59 2.108-1.59.763 0 2.206.161 2.321 1.926h4.089c-.07-3.369-2.823-4.836-6.344-4.836-2.156.025-3.973.645-5.109 1.765a4.446 4.446 0 00-1.274 3.121c0 3.098 2.065 4.339 4.407 5.05 2.628.802 4.365 1.28 4.365 2.726 0 .965-.763 1.928-2.271 1.928-1.926 0-2.624-1.136-2.669-2.271h-4.148c0 3.834 3.226 5.247 6.815 5.247 4.559 0 6.587-2.594 6.587-5.211M28.453 26H0L20.855 0h14.004l-6.406 26z" fill="#C00"/><path d="M24.099 10.601V5.004H19.3v5.597h-5.597V15.4h5.593v5.6h4.8v-5.6h5.601V10.6h-5.6z" fill="#fff"/></g><defs><clipPath id="clip0_644_56"><path fill="#fff" d="M0 0h112.196v26H0z"/></clipPath></defs></svg>
                  </div>
                  <div class="font-bold">
                    {{ tr('pages.sales.confirmation.card.title') }}
                  </div>
                </div>
                <div>
                  <img
                    srcset="~images/swiss/confirmation/confirmation-image@2x.png 2x, ~images/swiss/confirmation/confirmation-image.png 1x"
                    src="~images/swiss/confirmation/confirmation-image.png"
                    class="w-full rounded-b"
                  >
                </div>
              </div>

              <div class="text-white md:flex ticket">
                <div class="relative flex flex-col flex-1 p-6 pb-4 overflow-hidden md:p-4 bg-sw_primary rounded-xl">
                  <div class="flex-1">
                    <div class="w-16 h-4">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.427 34.416" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#fff"><path data-name="Path 28" d="M0 34.416c1.326-1.666 2.521-3.177 3.73-4.683Q15.293 15.308 26.885.901a2.317 2.317 0 011.507-.86C34.056-.02 39.72.001 45.393.01a6.6 6.6 0 01.675.083l-8.451 34.323zm25.374-27.75v7.435h-7.3v6.408h7.361v7.37h6.473v-7.378h7.307v-6.48h-7.361V6.666z"/><path data-name="Path 29" d="M67.913 6.284h5.574l3.565 14.12.276.012L81.472 6.27h5.532l4.145 14.06h.305l3.538-14.028h5.583l-6.038 21.85h-5.959l-4.19-14.409-.291-.022-4.2 14.424h-5.958z"/><path data-name="Path 30" d="M111.199 22.074h5.111c1.182 2.553 2.636 3.383 4.764 2.763a2.5 2.5 0 001.969-2.169 2.072 2.072 0 00-1.435-2.234c-1.451-.624-2.97-1.084-4.444-1.658a17.017 17.017 0 01-2.843-1.25 6.1 6.1 0 01.253-10.554 11.528 11.528 0 0110.609-.116 5.263 5.263 0 013.068 5.157h-5.157c-1.054-2.218-2.281-2.948-4.292-2.223a2.734 2.734 0 00-1.647 1.666 2.742 2.742 0 001.122 2.072 11.6 11.6 0 002.866 1.155c1.231.45 2.5.811 3.7 1.339a6.053 6.053 0 013.886 6.492 6.216 6.216 0 01-4.371 5.661 12.807 12.807 0 01-9.431-.2 5.654 5.654 0 01-3.728-5.901z"/><path data-name="Path 31" d="M130.821 22.113a2.64 2.64 0 01.507-.1c1.539-.008 3.078 0 4.767 0a3.1 3.1 0 003.155 2.934 4.614 4.614 0 002.536-.669 2.1 2.1 0 00-.276-3.684 30.151 30.151 0 00-3.9-1.546c-.8-.3-1.641-.521-2.424-.863a6.012 6.012 0 01-4-6.545 6 6 0 014.8-5.405 12.792 12.792 0 018.012.228 5.5 5.5 0 013.884 5.552h-5.1c-.892-2.3-2.21-2.87-4.535-2.176a2.406 2.406 0 00-1.428 1.572 2.4 2.4 0 00.862 1.934 12.514 12.514 0 002.952 1.3c1.311.495 2.68.852 3.958 1.42a5.985 5.985 0 013.778 6.418 6.15 6.15 0 01-4.328 5.7 12.861 12.861 0 01-9.436-.192 5.757 5.757 0 01-3.784-5.878z"/><path data-name="Path 32" d="M66.906 12.067h-4.954c-1.257-2.817-2.847-2.79-4.42-2.27a2.716 2.716 0 00-1.613 1.694 2.453 2.453 0 001.1 1.934 22.109 22.109 0 003.614 1.508c1.011.394 2.054.716 3.039 1.158a5.9 5.9 0 013.767 5.9 6.181 6.181 0 01-3.922 5.99 12.392 12.392 0 01-10.28-.254 5.467 5.467 0 01-3.275-5.621 2.56 2.56 0 01.5-.1c1.537-.008 3.076 0 4.586 0 1.207 2.625 2.763 3.5 4.922 2.8 1.037-.338 1.892-1.035 1.782-2.112a3.177 3.177 0 00-1.257-2.154 23.679 23.679 0 00-3.9-1.537c-.967-.367-1.97-.677-2.9-1.131a5.833 5.833 0 01-3.411-6.1 5.7 5.7 0 014.04-5.27 12.271 12.271 0 019.029.058 5.28 5.28 0 013.554 5.5z"/><path data-name="Path 33" d="M108.468 28.191h-5.513V6.339h5.513z"/></g></svg>
                    </div>
                    <p class="h-16 text-2xl font-bold">
                      {{ tr('pages.sales.confirmation.card.title') }}
                    </p>
                  </div>

                  <p class="text-xs">
                    {{ tr('pages.sales.confirmation.details.value') }}
                  </p>
                  <p class="pb-4 text-xl font-bold">
                    {{ voucherValueText }}
                  </p>

                  <p class="max-w-64 text-xxs">
                    {{ tr('pages.sales.confirmation.details.validUntilPhrase', { date:
                      $d(new Date(redeemableVoucher.validUntil), 'short')
                    }) }}
                  </p>

                  <div class="absolute bottom-0 right-0 w-full mr-2 -mb-6 opacity-25 max-w-32">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><switch><g><path d="M12.901 3.566l8.547 10.666 7.885.001h.011A1.772 1.772 0 0 1 31.1 16a1.77 1.77 0 0 1-1.75 1.768h-7.902l-8.547 10.666H9.573l6.272-10.668H7.63L4.96 20.434H1.662L4.557 16l-2.895-4.433H4.96l2.67 2.668h8.215L9.573 3.565h3.328m.432-.9H8l6.272 10.67h-6.27l-2.669-2.668H0L3.482 16 0 21.334h5.333l2.67-2.668h6.27L8 29.334h5.333l8.547-10.666h7.47a2.668 2.668 0 0 0 0-5.335h-7.47L13.333 2.666z" fill="#ffffff" /></g></switch></svg>
                  </div>
                </div>
                <div class="ticket__middle" />
                <div class="p-6 pb-4 space-y-4 md:space-y-0 md:p-4 md:flex md:flex-col md:w-40 bg-sw_primary rounded-xl">
                  <div class="md:mt-4">
                    <p class="pb-px leading-none text-xxs">
                      {{ tr('pages.sales.confirmation.details.code') }}
                    </p>
                    <p class="text-base" :class="{ 'font-bold': redeemableVouchers.length <= 1 }" data-testid="voucher-code">
                      {{ redeemableVouchers.length > 1 ? $t('pages.sales.confirmation.details.downloadToSeeCodes') : redeemableVoucher.code }}
                    </p>
                  </div>

                  <div class="p-4">
                    <img src="~images/austrian/qr/qr-code.png" class="w-full" alt="https://austrian.com">
                  </div>

                  <div class="text-center text-xxs">
                    <a :href="termsLink" class="underline hover:no-underline" target="_blank">
                      {{ tr('pages.sales.confirmation.details.terms') }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col items-center w-full max-w-lg mb-10 space-y-6 xl:w-1/2 xl:mb-0 xl:mt-7 xl:block md:space-y-12">
            <div>
              <ul class="space-y-4 md:space-y-8 list-checkmark-2 text-sn-gray-900">
                <li v-html="tr('pages.sales.buy.cards.point1')" />
                <li v-html="tr('pages.sales.buy.cards.point3')" />
                <li v-html="tr('pages.sales.buy.cards.point4')" />
              </ul>
            </div>

            <div class="relative md:w-full md:max-w-68">
              <Button
                variant="primary"
                :loading="downloadingPdf"
                full-width
                @click.prevent="downloadPdf()"
              >
                {{ tr('pages.sales.confirmation.button.download') }}
              </Button>
            </div>

          </div>
        </div>

        <div class="flex justify-center mt-10 xl:mt-24">
          <Button :href="$i18nTo({ name: 'voucherSaleLanding'})" variant="secondary">
            {{ tr('pages.sales.confirmation.button.return') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepNavigation from '~brand-components/swiss/navigation/step-navigation.vue'
import Button from '~brand-components/swiss/button/button.vue'
import VoucherSaleConfirmation from '~brand-pages/base/voucher-sale-confirmation'

export default VoucherSaleConfirmation.extend({
  components: {
    StepNavigation,
    Button,
  },
  computed: {
    termsLink() {
      if (this.$i18n.locale === 'de') {
        return 'https://www.swiss.com/ch/de/book-and-manage/conditions/voucher-conditions'
      }

      if (this.$i18n.locale === 'fr') {
        return 'https://www.swiss.com/ch/fr/book-and-manage/conditions/voucher-conditions'
      }

      if (this.$i18n.locale === 'it') {
        return 'https://www.swiss.com/ch/it/book-and-manage/conditions/voucher-conditions'
      }

      return 'https://www.swiss.com/ch/en/book-and-manage/conditions/voucher-conditions'
    },
  },
})
</script>

<style lang="scss" scoped>
.ticket {
  &__middle {
    position: relative;

    &:before {
      content: "";
      background-image: url("data:image/svg+xml,%3Csvg width='8' height='4' viewBox='0 0 8 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='white'/%3E%3C/svg%3E%0A");

      @apply block absolute left-0 top-0 w-full h-1 z-10 bg-repeat-x -mt-0.5;
    }
  }
}

@screen md {
.ticket {
  &__middle {
    &:before {
      background-image: url("data:image/svg+xml,%3Csvg width='4' height='8' viewBox='0 0 4 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='white'/%3E%3C/svg%3E%0A");

      @apply w-1 h-full bg-repeat-y mt-0 -ml-0.5;
    }
  }
}
}
</style>
